/*------------------------------------*\
    smooth scroll
\*------------------------------------*/

module.exports = function(){


    var hashTagActive = '';

    $('.js-scroll').click(function(event) {
        event.preventDefault();

        // Calculate destination

        var dest = 0;
        if ($(this.hash).offset().top > $(document).height() - $(window).height()) {
            dest = $(document).height() - $(window).height();
        } else {
            dest = $(this.hash).offset().top;
        }

        // Go to destination

        $('html, body').animate({
            scrollTop: dest - 50
        }, 2000, 'swing');
        hashTagActive = this.hash;
    });



    $('.js-scroll-timeout').click(function(event) {

        setTimeout(function() {

        var dest = 0;
        if ($(this.hash).offset().top > $(document).height() - $(window).height()) {
            dest = $(document).height() - $(window).height();
        } else {
            dest = $(this.hash).offset().top;
        }

        // Go to destination

        $('html, body').animate({
            scrollTop: dest - 50
        }, 2000, 'swing');
        hashTagActive = this.hash;

        }.bind(this), 100);

    });


}; // end of module.exports



// WEBPACK FOOTER //
// ./js-source/blocks/scroll.js